import { Box, Heading, Stack, Text, Divider, FormControl, FormLabel, RadioGroup, Radio, Grid, GridItem, Checkbox, HStack, Button, useToast } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { SUBMIT_QUESTIONNAIRE_MUTATION } from '../../Components/Graphql/Mutations';


const Questionnaire = () => {
    const navigate = useNavigate();
    const toast = useToast();
    const [submitQuestionnaireMutation, submitQuestionnaire] = useMutation(SUBMIT_QUESTIONNAIRE_MUTATION);
    const [investorType, setInvestorType] = useState('');
    const [regulationInvestor, setRegulationInvestor] = useState('');
    const [institutionalInvestorType, setInstitutionalInvestorType] = useState('');
    const [propertyType, setPropertyType] = useState([]);
    const [propertyClass, setPropertyClass] = useState([]);
    const [propertyWorth, setPropertyWorth] = useState('');
    const [riskTolerance, setRiskTolerance] = useState('');
    const investorTypeChange = (value) => {
        setInvestorType(value);
    };
    const regulationInvestorChange = (value) => {
        setRegulationInvestor(value);
    };
    const institutionalInvestorTypeChange = (value) => {
        setInstitutionalInvestorType(value);
    };
    const propertyTypeChange = (value) => {
        setPropertyType((prevCheckboxes) => {
            if (prevCheckboxes.includes(value)) {
                return prevCheckboxes.filter((item) => item !== value);
            } else {
                return [...prevCheckboxes, value];
            }
        });
    };
    const propertyClassChange = (value) => {
        setPropertyClass((prevCheckboxes) => {
            if (prevCheckboxes.includes(value)) {
                return prevCheckboxes.filter((item) => item !== value);
            } else {
                return [...prevCheckboxes, value];
            }
        });
    };
    const propertyWorthChange = (value) => {
        setPropertyWorth(value);
    };
    const riskToleranceChange = (value) => {
        setRiskTolerance(value);
    };
    useEffect(() => {
        console.log("*********");
        console.log("investorType", investorType);
        console.log("regulationInvestor", regulationInvestor);
        console.log("institutionalInvestorType", institutionalInvestorType);
        console.log("propertyType", propertyType);
        console.log("propertyClass", propertyClass);
        console.log("propertyWorth", propertyWorth);
        console.log("riskTolerance", riskTolerance);

    }, [investorType, regulationInvestor, institutionalInvestorType, propertyType, propertyClass, propertyWorth, riskTolerance]);
    const handleSubmit = async (e) => {
        e.preventDefault();
        const submitQuestionaireInput = {
            desiredPropertyClasses: propertyClass,
            desiredPropertyTypes: propertyType,
            investorInstitution: institutionalInvestorType,
            investorType: investorType,
            realEstateOwned: propertyWorth,
            riskTolerance: riskTolerance
        };
        console.log('submitQuestionaireInput:', submitQuestionaireInput);

        try {
            // Call the submitQuestionnaire mutation with the form data
            await submitQuestionnaireMutation({ variables: submitQuestionaireInput });

            // Handle successful submission (optional)
            console.log('Questionnaire submitted successfully!');
        } catch (err) {
            // Handle error (optional)
            console.error('Error submitting questionnaire', err);
        }
    };
    useEffect(() => {

        console.log("error:", submitQuestionnaire.error)
        console.log("loading:", submitQuestionnaire.loading)
        console.log("data:", submitQuestionnaire.data)

        if (submitQuestionnaire.data != undefined) {
            if (submitQuestionnaire?.data?.submitQuestionaire?.success) {
                toast({
                    title: 'Succeed',
                    description: 'Questionnaire is changed Successfully',
                    status: 'success',
                    duration: 4000,
                    isClosable: true
                });
            }
            else {
                toast({
                    title: 'error',
                    description: submitQuestionnaire?.data?.submitQuestionaire?.message,
                    status: 'error',
                    duration: 4000,
                    isClosable: true
                });
            }

        }
        if (submitQuestionnaire.error != undefined) {
            toast({
                title: 'error',
                description: submitQuestionnaire.error.message,
                status: 'error',
                duration: 4000,
                isClosable: true
            });
        }
    }, [submitQuestionnaire.data, submitQuestionnaire.loading, submitQuestionnaire.error])


    return (
        <Stack bgColor="#fafafa" my="70px" align="center" color="#1C3E64" lineHeight="30px" fontSize="14.4px" fontWeight="500">
            <Box bgColor="white" w={{ base: "90%", lg: "842px" }} maxW="1300px" p="50px" borderRadius="24px"  >
                <Heading textAlign="center" fontFamily="Raleway" fontSize="32px" color="#333">Questionnaire</Heading>
                <Text textAlign="center">Complete your profile so we can alert you on properties that matches your investment needs
                </Text>
                <Divider my="30px" color="#1C3E64" />
                <form onSubmit={handleSubmit}>
                    <FormControl isRequired>
                        <FormLabel fontSize="24px" color="#333" mb="8px">
                            Are you an individual or institutional investor?

                        </FormLabel>
                        <RadioGroup color="#1C3E64" onChange={investorTypeChange} value={investorType} >
                            <Grid templateColumns={{ base: "repeat(1, 1fr)", sm: "repeat(2, 1fr)" }} gap={4}>
                                <GridItem colSpan={1}>
                                    <Radio value="Individual">Individual</Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="Institutional">Institutional</Radio>
                                </GridItem>
                            </Grid>

                        </RadioGroup>
                    </FormControl>
                    {/* <Divider my="30px" color="#1C3E64" />
                    <FormControl isRequired>
                        <FormLabel fontSize="24px" color="#333" mb="8px">
                            Are you a Regulation D or Regulation S investor?

                        </FormLabel>
                        <RadioGroup color="#1C3E64" onChange={regulationInvestorChange} value={regulationInvestor} >
                            <Stack columnGap="40%" >
                                <Radio value="Regulation D">Regulation D (U.S. Accredited Investor)
                                </Radio>
                                <Text mb="24px">  In the U.S., the term Accredited Investor is used by the Securities and
                                    Exchange Commission (SEC) under Regulation D to refer to investors who
                                    are financially sophisticated and have a reduced need for the protection
                                    provided by regulatory disclosure filings. Regulation D investors must
                                    meet certain income or net worth or knowledge tests to be able to invest
                                    in Reg D offerings.</Text>
                                <Radio value="Regulation S">Regulation S (Investors outside the U.S.)</Radio>
                                <Text>
                                    Regulation S provides an SEC compliant way for US companies to raise capital from investors who are outside the U.S.
                                </Text>

                            </Stack>
                        </RadioGroup>
                    </FormControl> */}
                    <Divider my="30px" color="#1C3E64" />
                    <FormControl isRequired>
                        <FormLabel fontSize="24px" color="#333" mb="8px">
                            If you are an Institutional Investor, what kind of institution do you represent? Select closest answer.

                        </FormLabel>
                        <RadioGroup color="#1C3E64" onChange={institutionalInvestorTypeChange} value={institutionalInvestorType}>
                            <Grid templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }} gap={4}>
                                <GridItem colSpan={1}>
                                    <Radio value="FamilyTrust">Family Office/Trust</Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="PrivateEquity">Private Equity</Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="HedgeFund">Hedge Fund</Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="InsuranceCompany">Bank or Insurance Company</Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="BrokerDealer">Broker-Dealer</Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="RegisteredInvestmentAdvisor">Registered Investment</Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="MutualFund">Mutual Fund</Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="SovereignWealthFund">Sovereign Wealth Fund</Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="RetirementPlan">Pension/Retirement Plan</Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="NonProfit">Endowment or Non-Profit</Radio>
                                </GridItem>

                                <GridItem colSpan={1}>
                                    <Radio value="Corporation">Corporation or Real Estate Investment Trust</Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="VentureCapital">Venture Capital</Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="Others">Other Business Partnership</Radio>
                                </GridItem>
                            </Grid>

                        </RadioGroup>
                    </FormControl>

                    <Divider my="30px" color="#1C3E64" />
                    <FormControl>
                        <FormLabel fontSize="24px" color="#333" mb="8px">
                            What property types are you most interested in?

                        </FormLabel>

                        <Grid templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }} gap={4}>
                            <GridItem colSpan={1}>
                                <Checkbox isChecked={propertyType.includes("Apartments")}
                                    onChange={() => propertyTypeChange("Apartments")}>
                                    Apartments

                                </Checkbox>

                            </GridItem>
                            <GridItem colSpan={1}>
                                <Checkbox isChecked={propertyType.includes("Office")}
                                    onChange={() => propertyTypeChange("Office")}>
                                    Commercial
                                </Checkbox>
                            </GridItem>
                            <GridItem colSpan={1}>
                                <Checkbox isChecked={propertyType.includes("Retail")}
                                    onChange={() => propertyTypeChange("Retail")}>
                                    Retail
                                </Checkbox>
                            </GridItem>
                            <GridItem colSpan={1}>
                                <Checkbox isChecked={propertyType.includes("StudentHousing")}
                                    onChange={() => propertyTypeChange("StudentHousing")}>
                                    Student housing
                                </Checkbox>
                            </GridItem>
                            <GridItem colSpan={1}>
                                <Checkbox isChecked={propertyType.includes("Hospitality")}
                                    onChange={() => propertyTypeChange("Hospitality")}>
                                    Hospitality
                                </Checkbox>
                            </GridItem>
                            <GridItem colSpan={1}>
                                <Checkbox isChecked={propertyType.includes("Industrial")}
                                    onChange={() => propertyTypeChange("Industrial")}>
                                    Industrial
                                </Checkbox>
                            </GridItem>
                            <GridItem colSpan={1}>
                                <Checkbox isChecked={propertyType.includes("MixedUse")}
                                    onChange={() => propertyTypeChange("MixedUse")}>
                                    Mixed use
                                </Checkbox>
                            </GridItem>
                            <GridItem colSpan={1}>
                                <Checkbox isChecked={propertyType.includes("Condominium")}
                                    onChange={() => propertyTypeChange("Condominium")}>
                                    Condominium
                                </Checkbox>
                            </GridItem>

                        </Grid>


                    </FormControl>

                    <Divider my="30px" color="#1C3E64" />
                    <FormControl >
                        <FormLabel fontSize="24px" color="#333" mb="8px">
                            What property class you're interested in?


                        </FormLabel>
                        <RadioGroup color="#1C3E64" >
                            <Grid templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }} gap={4}>
                                <GridItem colSpan={1}>
                                    <Checkbox isChecked={propertyClass.includes("A")}
                                        onChange={() => propertyClassChange("A")}>
                                        Class A
                                    </Checkbox>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Checkbox isChecked={propertyClass.includes("B")}
                                        onChange={() => propertyClassChange("B")}>
                                        Class B
                                    </Checkbox>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Checkbox isChecked={propertyClass.includes("C")}
                                        onChange={() => propertyClassChange("C")}>
                                        Class C
                                    </Checkbox>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Checkbox isChecked={propertyClass.includes("Mixed")}
                                        onChange={() => propertyClassChange("Mixed")}>
                                        Mixed Class
                                    </Checkbox>
                                </GridItem>

                            </Grid>

                        </RadioGroup>
                    </FormControl>
                    <Divider my="30px" color="#1C3E64" />
                    <FormControl isRequired>
                        <FormLabel fontSize="24px" color="#333" mb="8px">
                            How much Commercial Real Estate do you currently own?

                        </FormLabel>
                        <RadioGroup color="#1C3E64" onChange={propertyWorthChange} value={propertyWorth} >
                            <Grid templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }} gap={4}>
                                <GridItem colSpan={1}>
                                    <Radio value="Under 1000000">Under $1,000,000
                                    </Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="1000000 - 1500000">$1,000,000 - $1,500,000
                                    </Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="1500000 - 300000">$1,500,000 - $3,000,000
                                    </Radio>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Radio value="3000000 and Over">$3,000,000 and Over</Radio>
                                </GridItem>

                            </Grid>

                        </RadioGroup>
                    </FormControl>
                    <Divider my="30px" color="#1C3E64" />
                    <FormControl isRequired>
                        <FormLabel fontSize="24px" color="#333" mb="8px">
                            Please indicate which of the following most closely matches your investment risk tolerance level.

                        </FormLabel>
                        <RadioGroup id="investment-risk" color="#1C3E64" onChange={riskToleranceChange} value={riskTolerance} >


                            <Radio value="Conservative"><b>Conservative:</b>  I want to preserve my initial investment, with minimum risk, even if that means the investments do not generate significant income or returns and may not keep pace with inflation.</Radio>
                            <Radio value="ModeratelyConservative"><b>Moderately Conservative:</b>   I am willing to accept a low risk to my initial investment, including low volatility, to seek a modest level of return on my investment.</Radio>
                            <Radio value="Moderate"><b>Moderate:</b>   I am willing to accept some risk to my initial investment and tolerate some volatility to seek higher returns and understand I could lose a portion of the money invested.
                            </Radio>
                            <Radio value="ModeratelyAggressive"><b>Moderately Aggressive:</b>   I am willing to accept high risk to my initial investment, including high volatility, to seek high returns over time, and understand I could lose a substantial amount of the money invested.</Radio>
                            <Radio value="SignificantRisk"><b>Significant Risk:</b>   I am willing to accept maximum risk to my initial investment to aggressively seek maximum returns, and understand I could lose most, or all, of the money invested.</Radio>

                        </RadioGroup>
                    </FormControl>
                    <Divider my="30px" color="#1C3E64" />
                    <HStack justifyContent="space-between">
                        <Button variant="ghost" fontSize="14.4px" onClick={() => navigate('/profile')} > Cancel</Button>
                        <Button type="submit" border="1px solid #002B5B" _hover={{ color: "#002B5B", bgColor: "white" }} w={{ base: "104px", md: "359px" }} fontFamily="Raleway" bgColor="#002B5B" color="white" fontSize="14.4px" p="12px 26px">Submit</Button>
                    </HStack>
                </form>
            </Box>

        </Stack>
    );
}

export default Questionnaire;